import { defaultConfig } from '@/config/config';
import { ConfigContext } from '@/context/ConfigContext';
import { useState } from 'react';

export const ConfigContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [configState, setConfigState] = useState(defaultConfig);
  const [serverInfo, setServerInfo] = useState<string>();

  return (
    <ConfigContext.Provider
      value={{
        config: configState,
        setConfig: setConfigState,
        serverInfo: serverInfo,
        setServerInfo: setServerInfo
      }}
    >
      {children}
    </ConfigContext.Provider>
  );
};
